// extracted by mini-css-extract-plugin
module.exports = {"loadingBase":"#257E43","titleContainer":"styles_titleContainer__21uud","title":"styles_title__IEzgB","hidden":"styles_hidden__2G-05"};